// ============================================================================
// Canonical Cattle Daily detail route contract
// ============================================================================
//
// This pure pathname predicate is intentionally shared by the generic
// authenticated-surface resolver and the released-render boundary. It contains
// no ledger, renderer, or data-owner knowledge: its only job is to keep the
// one independently reviewed record form from drifting wider than the legacy
// CattleDailysRouter, which deliberately accepts every non-empty suffix.
// ============================================================================

export const CATTLE_DAILYS_DETAIL_PATHNAME_PREFIX = '/cattle/dailys/';

/**
 * Accept exactly one meaningful raw path segment. Decode before final
 * validation so an encoded separator, NUL, line break, or dot segment cannot turn a
 * record capability into a broader legacy route claim.
 */
export function isCanonicalCattleDailysDetailPathname(pathname: unknown): pathname is string {
  if (typeof pathname !== 'string' || !pathname.startsWith(CATTLE_DAILYS_DETAIL_PATHNAME_PREFIX)) {
    return false;
  }

  const rawId = pathname.slice(CATTLE_DAILYS_DETAIL_PATHNAME_PREFIX.length);
  if (
    rawId === '' ||
    rawId.includes('/') ||
    rawId.includes('\\') ||
    rawId.includes('\0') ||
    rawId.includes('\r') ||
    rawId.includes('\n')
  ) {
    return false;
  }

  try {
    const id = decodeURIComponent(rawId);
    return (
      id.trim() !== '' &&
      id !== '.' &&
      id !== '..' &&
      !id.includes('/') &&
      !id.includes('\\') &&
      !id.includes('\0') &&
      !id.includes('\r') &&
      !id.includes('\n')
    );
  } catch {
    return false;
  }
}
